import { DatePicker } from "@shared/ui";
import { Flex } from "antd";
import dayjs, { Dayjs } from "dayjs";
import styles from "../styles.module.scss";

export type DeadlinePreset = "24h" | "48h" | "custom";

interface DeadlinePickerProps {
  preset: DeadlinePreset;
  onChangePreset: (preset: DeadlinePreset) => void;
  customDate: Dayjs | null;
  onChangeCustomDate: (date: Dayjs | null) => void;
}

const PRESET_OPTIONS: { id: DeadlinePreset; label: string }[] = [
  { id: "24h", label: "24 hours" },
  { id: "48h", label: "48 hours" },
  { id: "custom", label: "Custom" },
];

function getDisabledTime(current?: Dayjs) {
  if (!current || !current.isSame(dayjs(), "day")) {
    return {};
  }

  const now = dayjs();

  return {
    disabledHours: () =>
      Array.from({ length: now.hour() }, (_, hour) => hour),
    disabledMinutes: (selectedHour: number) => {
      if (selectedHour > now.hour()) {
        return [];
      }
      return Array.from({ length: now.minute() }, (_, minute) => minute);
    },
  };
}

export function DeadlinePicker({
  preset,
  onChangePreset,
  customDate,
  onChangeCustomDate,
}: DeadlinePickerProps) {
  return (
    <div className={styles.section}>
      <div className={styles.sectionTitle}>Response deadline</div>
      <Flex gap={8} wrap="wrap">
        {PRESET_OPTIONS.map((opt) => (
          <button
            key={opt.id}
            type="button"
            onClick={() => onChangePreset(opt.id)}
            className={`${styles.presetChip} ${
              preset === opt.id ? styles.presetChipSelected : ""
            }`}
          >
            {opt.label}
          </button>
        ))}
      </Flex>
      {preset === "custom" && (
        <DatePicker
          showTime={{ format: "HH:mm" }}
          format="DD MMM YYYY, HH:mm"
          value={customDate}
          onChange={(date) => onChangeCustomDate(date)}
          disabledDate={(current) =>
            !!current && current < dayjs().startOf("day")
          }
          disabledTime={getDisabledTime}
          className={styles.customDatePicker}
          allowClear={false}
          placeholder="Pick date and time"
        />
      )}
    </div>
  );
}
